import React from "react";
import { useDownloadNominationDocument } from "@features/vessel-nomination/nomination-details/hooks/useDownloadNominationDocument";

const SERVICE = "bff-vessel";

interface Props {
  url: string;
  name: string;
  className?: string;
}

/** The blob is private: open it through the SAS-token preview of the liquid nomination, never by its raw URL. */
const AttachmentFileLink: React.FC<Props> = ({ url, name, className = "" }) => {
  const { handlePreview } = useDownloadNominationDocument();

  return (
    <button
      type="button"
      className={`text-blue-700 underline text-left cursor-pointer ${className}`.trim()}
      onClick={() => handlePreview(SERVICE, url)}
    >
      {name}
    </button>
  );
};

export default AttachmentFileLink;
